import FieldInput from 'components/FieldInput';

const NameField = FieldInput;

export default NameField;